module.exports = __webpack_public_path__ + "img/e.4f491c66.svg";